import React from 'react';
import {
  Box,
  Container,
  Text,
  HStack,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';

type AppPage = 'main' | 'privacy' | 'contact';

interface FooterProps {
  onNavigate: (page: AppPage) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const bgColor = useColorModeValue('gray.100', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const linkColor = useColorModeValue('blue.500', 'blue.300');

  return (
    <Box bg={bgColor} py={6} mt="auto">
      <Container maxW="container.xl">
        <HStack
          justify="space-between"
          align="center"
          direction={{ base: 'column', md: 'row' }}
          spacing={{ base: 2, md: 6 }}
        >
          <HStack spacing={6} wrap="wrap" justify="center">
            <Link
              onClick={() => onNavigate('privacy')}
              color={linkColor}
              fontSize="sm"
              cursor="pointer"
              _hover={{ textDecoration: 'underline' }}
            >
              プライバシーポリシー
            </Link>
            <Link
              onClick={() => onNavigate('contact')}
              color={linkColor}
              fontSize="sm"
              cursor="pointer"
              _hover={{ textDecoration: 'underline' }}
            >
              お問い合わせ
            </Link>
          </HStack>
          <Text color={textColor} fontSize="sm">
            ©from-garage 2025 All Rights Reserved.
          </Text>
        </HStack>
      </Container>
    </Box>
  );
};

export default Footer;